// import hooks
import { useState, useCallback } from "react";
import isUndefined from "../../common-utils/undefined/isUndefined.util.js";
export const useBooleanState = (initialValue) => {
    const [value, setValue] = useState(isUndefined(initialValue) ? false : initialValue);
    const setTrue = useCallback(() => setValue(true), []);
    const setFalse = useCallback(() => setValue(false), []);
    const toggle = useCallback(() => setValue((o) => !o), []);
    return {
        value,
        setTrue,
        setFalse,
        toggle,
    };
};
export default useBooleanState;
